module.exports = __webpack_public_path__ + "media/images/athletes/931-4d30b56210ec4ac13adb29395f5df1d9.png";